import { Component, OnDestroy, OnInit } from '@angular/core';
import { distinctUntilChanged, filter, map, Observable, of, Subject, Subscription, switchMap, takeUntil, tap, timer } from 'rxjs';
import { StateService } from 'src/app/services';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnDestroy {

  //public loading = false;

  public show = false;
  public mode: 'determinate' | 'indeterminate' = 'indeterminate';
  public progress = 0;
  public action: string;

  private destroy$ = new Subject<void>();
  private displayDelayMs = 600;

  constructor(stateService: StateService) {
    // Figyeljük a show állapotot külön
    stateService.state.spinner.obs$
      .pipe(
        // Csak a show változását figyeljük
        distinctUntilChanged((a, b) => a.show === b.show),
        switchMap(spinnerState => {
          if (spinnerState.show && !this.show) {
            //console.log('Spinner timer started');
            return timer(this.displayDelayMs).pipe(
              map(() => true),
              //tap(() => console.log('Timer completed, show: true'))
            );
          }
          //console.log('Immediate show applied:', spinnerState.show);
          return of(spinnerState.show);
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(show => {
        //console.log('Show state applied:', show);
        this.show = show;
      });

    // Külön figyeljük a mode, progress és action változásokat
    stateService.state.spinner.obs$
      .pipe(
        distinctUntilChanged((a, b) => a.mode === b.mode && a.progress === b.progress && a.action === b.action),
        takeUntil(this.destroy$)
      )
      .subscribe(spinnerState => {
        //console.log('Spinner properties applied:', spinnerState);
        this.mode = spinnerState.mode;
        this.progress = spinnerState.progress ?? 0;
        this.action = spinnerState.action;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
